import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { providerServiceTypesDataSource } from 'infrastructure/data-sources/provider-service-types';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IProviderServiceTypeItem } from 'infrastructure/data-sources/provider-service-types';

type Options = IBaseSelectBoxOption<
  IProviderServiceTypeItem['id'],
  IProviderServiceTypeItem
>[];

interface IProviderServiceTypeSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ProviderServiceTypeSelectBox: React.FC<
  IProviderServiceTypeSelectBoxProps
> = (props) => {
  const dataSource = useMemo(() => providerServiceTypesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ProviderServiceTypeSelectBox;
